const YellowWarning = () => {
  return (
    <svg
      className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-500"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
    </svg>
  );
};

export default YellowWarning;
